module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "TOC--Title",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/BlackAndResilient4#_idTextAnchor028"
    }
  }, [_vm._v("This Is Your Time"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" to Shine")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/BlackAndResilient9#_idTextAnchor029"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BlackAndResilient9#_idTextAnchor029"
    }
  }, [_vm._v("Part I: His Name Is Trayvon")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient14#_idTextAnchor030",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient14#_idTextAnchor030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talking About Racism/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Write a Letter t")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("o Someone")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient18#_idTextAnchor031",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient18#_idTextAnchor031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Racism Affects You/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Self-Ex")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("ploration")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient22#_idTextAnchor032",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient22#_idTextAnchor032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Physical Toll of Racism/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Le")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("t It Out!")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient26#_idTextAnchor033",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient26#_idTextAnchor033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mental Toll of Racism/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Writin")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("g Emotion")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient30#_idTextAnchor034",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient30#_idTextAnchor034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coping Strategies/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Write Poetry and C")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("reate Art")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient34#_idTextAnchor035",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient34#_idTextAnchor035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Write in Nature/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("editation")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient38#_idTextAnchor036",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient38#_idTextAnchor036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding Microaggressions/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Your Life in ")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Metaphors")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient42#_idTextAnchor038",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient42#_idTextAnchor038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Sanctuary/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Finding a S")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("afe Space")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient46#_idTextAnchor039",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient46#_idTextAnchor039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: The Art of the Comeback")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient52#_idTextAnchor040",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient52#_idTextAnchor040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Actions…and How to Respond/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Proble")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("m Solving")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient56#_idTextAnchor042",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient56#_idTextAnchor042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Myth of Reverse Racism/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Prompting a ")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Reckoning")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient60#_idTextAnchor043",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient60#_idTextAnchor043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: Living While Black")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient65#_idTextAnchor044",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient65#_idTextAnchor044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intersectionality/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("The Story of ")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Your Life")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient69#_idTextAnchor046",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient69#_idTextAnchor046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding Systemic Racism/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Write a Letter to")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v(" Yourself")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient73#_idTextAnchor048",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient73#_idTextAnchor048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Never Argue with an Idiot/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Ta")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("lk It Out")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient77#_idTextAnchor050",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient77#_idTextAnchor050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Racial Profiling and Police E"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ncounters/")]), _c('br'), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Childhood Dreams a")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("nd Heroes")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient81#_idTextAnchor055",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient81#_idTextAnchor055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Rights During a Police "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Encounter/")]), _c('br'), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Remembering Wh")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("o You Are")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient85#_idTextAnchor057",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient85#_idTextAnchor057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to (Somewhat) Stay Safe During a Police Encounter/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Journal with Ph")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("otographs")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient89#_idTextAnchor059",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient89#_idTextAnchor059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Fight Systemic Racism/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Visu")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("alization")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient93#_idTextAnchor060",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient93#_idTextAnchor060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV: Creativity and Self-Confidence")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient98#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient98#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Esteem and Confidence/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Writing fo")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("r Purpose")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient102#_idTextAnchor063",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient102#_idTextAnchor063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clarify Your Values"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("/")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Powerful")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient106#_idTextAnchor064",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient106#_idTextAnchor064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Best Life/"), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Use Your Im")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("agination")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient110#_idTextAnchor065",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient110#_idTextAnchor065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Encourage Confidence "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("in Others/")]), _c('br'), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Reframe Your Pe")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("rspective")])])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  })])]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient114#_idTextAnchor066",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient114#_idTextAnchor066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Congratulations!")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/BlackAndResilient115#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/BlackAndResilient115#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39cc5db8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlackAndResilient3.vue
// module id = 69
// module chunks = 0